import {Component, computed, inject, input} from '@angular/core';
import {ProviderTenderRfqControllerService, TenderDetailResponse} from '@frontend/shared-api';
import {rxResource} from '@angular/core/rxjs-interop';
import {LoadingComponent} from '../../../../../shared/components/loading/loading.component';
import {SystemRecordingIntegrationPanelsComponent} from '../../../../customer/project-sequence/chapter/chapter-8-rfq/step-8-2-invitation-preview/step-8-2-2-rfq-system-integration/components/system-recording-integration-panels/system-recording-integration-panels.component';

@Component({
  selector: 'app-tender-project-rfq-proposal-system-integration',
  imports: [LoadingComponent, SystemRecordingIntegrationPanelsComponent],
  templateUrl: './tender-rfq-proposal-system-integration.component.html',
})
export class TenderRfqProposalSystemIntegrationComponent {
  private readonly providerTenderRfqController = inject(ProviderTenderRfqControllerService);

  readonly tenderDetails = input.required<TenderDetailResponse>();

  protected readonly tenderId = computed(() => this.tenderDetails().tenderId);
  protected readonly projectId = computed(() => this.tenderDetails().projectId);

  protected readonly systemIntegrationResource = rxResource({
    params: () => ({tenderId: this.tenderId()}),
    stream: ({params: request}) =>
      this.providerTenderRfqController.getSystemIntegrations({tenderId: request.tenderId}),
  });

  protected readonly currentOfficeSystemRecording = computed(
    () => this.systemIntegrationResource.value()?.currentSystemRecordingTools,
  );

  protected readonly targetOfficeSystemRecording = computed(
    () => this.systemIntegrationResource.value()?.targetSystemRecordingTools,
  );

  protected readonly integrationSystemRecordings = computed(
    () => this.systemIntegrationResource.value()?.integrationSystemRecordingTools,
  );
}
